import { Avatar, Box, Divider, Grid, Rating, Typography } from '@mui/material'
import React from 'react'
import RatingBar from '../../Common/RatingBar'

const noise = {
  5: "Can't recall",
  4: 'Low',
  3: 'Moderate',
  2: 'Noisy',
  1: 'Too noisy',
};

const Reviews = ({data}) => {
  return (
    <>
     <Typography
                      sx={{ fontWeight: 700, fontSize: '12px', mb: 3 }}
                    >
                      Reviews
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Box>
                          <Typography sx={{ fontWeight: 500 }}>
                            Overall rating
                          </Typography>
                          <Typography
                            sx={{ fontWeight: 700, fontSize: '24px', my: 2 }}
                          >
                            {data?.ReviewDetails?.Rating || '--'}
                          </Typography>
                          <Rating
                            readOnly
                            value={4}
                            sx={{ color: '#BC172F', fontSize: '14px' }}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Box>
                          <RatingBar
                            rate={5}
                            value={data?.ReviewDetails?.StarsPercentage?.Five}
                          />
                          <RatingBar
                            rate={4}
                            value={data?.ReviewDetails?.StarsPercentage?.Four}
                          />
                          <RatingBar
                            rate={3}
                            value={data?.ReviewDetails?.StarsPercentage?.Three}
                          />
                          <RatingBar
                            rate={2}
                            value={data?.ReviewDetails?.StarsPercentage?.Two}
                          />
                          <RatingBar
                            rate={1}
                            value={data?.ReviewDetails?.StarsPercentage?.One}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                    <Divider sx={{ my: 1 }} />
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        columnGap: 2,
                        overflow: 'scroll',
                      }}
                      className="hide_scrollbar"
                    >
                      <Box>
                        <Typography sx={{ fontSize: '12px' }}>Food </Typography>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: '12px',
                            textAlign: 'center',
                          }}
                        >
                          {data?.ReviewDetails?.CategoryRating?.Food || '--'}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography sx={{ fontSize: '12px' }}>
                          Service{' '}
                        </Typography>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: '12px',
                            textAlign: 'center',
                          }}
                        >
                          {data?.ReviewDetails?.CategoryRating?.Service || '--'}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography sx={{ fontSize: '12px' }}>
                          Ambience{' '}
                        </Typography>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: '12px',
                            textAlign: 'center',
                            textAlign: 'center',
                          }}
                        >
                          {data?.ReviewDetails?.CategoryRating?.Ambience ||
                            '--'}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <Typography sx={{ fontSize: '12px' }}>
                          Noise{' '}
                        </Typography>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: '12px',
                            textAlign: 'center',
                          }}
                        >
                          {noise[
                            data?.ReviewDetails?.CategoryRating?.NoiseLevels?.toFixed(
                              0,
                            )
                          ] || '--'}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ mt: 2 }}>
                      {!data?.ReviewDetails?.Reviews ||
                      data?.ReviewDetails?.Reviews?.legth === 0 ? (
                        <></>
                      ) : (
                        <>
                          {data?.ReviewDetails?.Reviews.map((review, i) => (
                            <Box key={i} sx={{ pb: 2 }}>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  columnGap: 2,
                                }}
                              >
                                <Avatar
                                  sx={{ bgcolor: '#013220', fontSize: '12px' }}
                                >
                                  {review?.ProfileImage ? (
                                    <img
                                      src={review?.ProfileImage}
                                      width={40}
                                    />
                                  ) : (
                                    review?.UserName?.substring(0, 2)
                                  )}
                                </Avatar>
                                <Box>
                                  <Typography sx={{ fontSize: '12px' }}>
                                    {review?.UserName || 'Annymous'}
                                  </Typography>
                                  <Typography sx={{ fontSize: '10px' }}>
                                    {getOneMonthAgo(review?.DateAdded) || '--'}{' '}
                                    . {review?.Time}
                                  </Typography>
                                </Box>
                              </Box>
                              <Rating
                                readOnly
                                value={review?.Rating}
                                precision={0.5}
                                sx={{
                                  fontSize: '12px',
                                  color: '#BC172F',
                                  my: 1,
                                }}
                              />
                              <Typography sx={{ fontSize: '10px' }}>
                                {review?.Comment}
                              </Typography>
                            </Box>
                          ))}
                        </>
                      )}
                    </Box>
    </>
  )
}

export default Reviews;


const getOneMonthAgo = (dateString) => {
  const date = new Date(dateString);

  date.setMonth(date.getMonth() - 1);

  const formattedDate = `${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`;

  return formattedDate;
};
